import React, { useState } from 'react';
import { Activity, BarChart3, Network, Clock, TrendingUp, Users, BookOpen } from 'lucide-react';
import { alertsAPI } from '../services/api';
import KnowledgeGraph from '../components/KnowledgeGraph';
import TimeMachine from '../components/TimeMachine';
import RLHFDashboard from '../components/RLHFDashboard';
import ObservabilityDashboard from '../components/ObservabilityDashboard';
import UserManagement from '../components/UserManagement';
import Documentation from '../components/Documentation';

function Admin() {
  const [activeTab, setActiveTab] = useState('overview');

  const generateAlerts = async () => {
    try {
      await alertsAPI.generate();
      alert('Alerts generated successfully!');
    } catch (error) {
      console.error('Error generating alerts:', error);
    }
  };

  const tabs = [
    { id: 'overview', label: 'Overview', icon: BarChart3 },
    { id: 'time-machine', label: 'Time Machine', icon: Clock },
    { id: 'knowledge-graph', label: 'Knowledge Graph', icon: Network },
    { id: 'rlhf', label: 'RLHF Dashboard', icon: TrendingUp },
    { id: 'observability', label: 'Observability', icon: Activity },
    { id: 'users', label: 'User Management', icon: Users },
    { id: 'documentation', label: 'Documentation', icon: BookOpen }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Admin & Advanced Analytics</h1>
        <p className="page-subtitle">System insights, AI performance, and advanced features</p>
      </div>

      {/* Tabs */}
      <div style={{ marginBottom: '24px', borderBottom: '2px solid var(--border-light)' }}>
        <div style={{ display: 'flex', gap: '8px' }}>
          {tabs.map(tab => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: '12px 20px',
                  border: 'none',
                  background: 'transparent',
                  borderBottom: activeTab === tab.id ? '3px solid var(--primary-500)' : '3px solid transparent',
                  color: activeTab === tab.id ? 'var(--primary-600)' : 'var(--text-secondary)',
                  fontWeight: activeTab === tab.id ? '600' : '500',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.2s',
                  fontSize: '0.875rem'
                }}
                data-testid={`tab-${tab.id}`}
              >
                <Icon size={18} />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === 'overview' && (
        <div>
          <div className="card" style={{ marginBottom: '24px' }}>
            <h3 className="card-title">Quick Actions</h3>
            <div className="grid grid-cols-2" style={{ gap: '12px', marginTop: '16px' }}>
              <button
                onClick={generateAlerts}
                className="btn btn-secondary"
                style={{ justifyContent: 'center', padding: '16px' }}
                data-testid="generate-alerts-btn"
              >
                <Activity size={20} />
                Generate Alerts from Monitor Agent
              </button>
              <button
                onClick={() => setActiveTab('knowledge-graph')}
                className="btn btn-secondary"
                style={{ justifyContent: 'center', padding: '16px' }}
              >
                <Network size={20} />
                View Knowledge Graph
              </button>
            </div>
          </div>
          <ObservabilityDashboard />
        </div>
      )}

      {activeTab === 'time-machine' && <TimeMachine />}
      {activeTab === 'knowledge-graph' && <KnowledgeGraph />}
      {activeTab === 'rlhf' && <RLHFDashboard />}
      {activeTab === 'observability' && <ObservabilityDashboard />}
      {activeTab === 'users' && <UserManagement />}
      {activeTab === 'documentation' && <Documentation />}
    </div>
  );
}

export default Admin;
